import { Injectable } from '@angular/core';
import { Route } from '@angular/router';
import { ComponentStatesOnRoutesService } from '@app/services/component-states-on-routes.service';
import { UserTabComponentConfigurationsService } from '@app/services/user-tab-config.service';
import { concat, forkJoin, Observable, of } from 'rxjs';
import { filter, map, mergeMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class BadgeMenuService {

  constructor(
    private userTabComponentConfigurationsService: UserTabComponentConfigurationsService,
    private componentEventService: ComponentStatesOnRoutesService) { }

  public showBadge(route: Route): Observable<boolean> {
    return concat(
      of(false),
      this.componentEventService
        .state$
        .pipe(
          filter(componentsOnRouteState => {
            return componentsOnRouteState.RouteMap.has(`/${route.path}`);
          }),
          mergeMap((componentsOnRouteState) => {
            return forkJoin([this.userTabComponentConfigurationsService.getUserTabConfig(), of(componentsOnRouteState)]);
          }),
          map(([userTabComponentConfiguration, componentsOnRouteState]) => {
            const myBoardRoute = componentsOnRouteState.RouteMap.get(`/${route.path}`);
            const foundComponent = myBoardRoute?.find(component => component.ShowBadge === true);
            if (foundComponent) {
              const componentIsHidden = userTabComponentConfiguration?.some(d => d.ComponentId === foundComponent.ComponentId && d.Hidden);
              if (!componentIsHidden) {
                return true;
              }
            }
            return false;
          })));
  }
}
